import {
  createColorSwatch,
  finalizeColorSwatch,
  finalizeColorSwatchValue
} from './paletteBuilder/colorSwatch';
import {
  createColorStack,
  finalizeColorStack
} from './paletteBuilder/colorStack';
import {
  createColorPalette,
  finalizeColorPalette
} from './paletteBuilder/colorPalette';

import {
  standardLabels,
  standardDefinitions
} from './paletteBuilder/standardColors';

import defaultFormula from './formulas/carinaDefaultFormula';
import darkFormula from './formulas/carinaDarkFormula';

export {
  createColorSwatch,
  finalizeColorSwatch,
  finalizeColorSwatchValue,
  createColorStack,
  finalizeColorStack,
  createColorPalette,
  finalizeColorPalette,
  standardLabels,
  standardDefinitions,
  defaultFormula,
  darkFormula
};

export default {
  createColorSwatch,
  finalizeColorSwatch,
  finalizeColorSwatchValue,
  createColorStack,
  finalizeColorStack,
  createColorPalette,
  finalizeColorPalette,
  standardLabels,
  standardDefinitions,
  defaultFormula,
  darkFormula
};
